import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { UploadDocumentacion } from './components/UploadDocumentacion';
import CustomizedSnackbars from '../Notifications/SnackBar';

const AdjuntarDocumentacionPage = () => {
  const history = useHistory();
  const { autorizacion } = history?.location?.state || {};

  const [message, setMessage] = useState({
    open: false,
    message: null,
    severity: 'success',
  });

  return (
    <>
      <UploadDocumentacion
        autorizacion={autorizacion}
        message={message}
        setMessage={setMessage}
      />

      <CustomizedSnackbars
        open={message.open}
        autoHideDuration={6000}
        onDeleteMessage={() => {
          setMessage({
            open: false,
            message: null,
            severity: 'success',
          });
        }}
        severity={message.severity}
        message={message.message}
      />
    </>
  );
};

export default AdjuntarDocumentacionPage;
